export default __webpack_public_path__ + "static/media/blaze-wizard.737907e4.png";